import { Component, OnInit, ViewEncapsulation, Renderer2, EventEmitter, Output } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { Menu } from '../../models/menu';
import { menuList } from '../../models/menulist';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { MessageCountService } from '../../../../pages/messages/services/message-count-service/message-count.service';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { PrifactRoute } from '../../../../../models/prifact-route';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent extends ComponentBase implements OnInit {

  @Output() onMenuClicked: EventEmitter<number> = new EventEmitter();

  selectedMenuItem: Menu;
  messageCount: number;
  menuList = menuList;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(private pageHeadingService: PageHeadingService,
    private messageCountService: MessageCountService
    , private routingService: RoutingService) {
    super();
  }

  ngOnInit() {
    let pageHeadingSubscription = this.pageHeadingService.menu$
      .subscribe(menu => {
        this.selectedMenuItem = menu;
      });

    let messageCountSubscription = timer(0, 20000).pipe(
      switchMap(res => {
        return this.messageCountService.getUnreadMessageCount()
      }))
      .subscribe(count => {
        this.messageCount = count;
      });


    this.addSubscription(pageHeadingSubscription);
    this.addSubscription(messageCountSubscription);
  }

  menuClicked(menu: Menu) {
    if (menu.isExternalUrl) {
      window.open(window.location.origin + "/" + menu.route);
    }
    else {
      let route = new PrifactRoute();
      route.url = "/pages/" + menu.route;
      route.page_name = menu.name;
      route.clear_history = true;
      this.routingService.navigate(route);
      this.onMenuClicked.emit();
    }
  }

}
